import React from 'react'

export const ExplainTypography = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  (props, ref) => {
    const { className, ...rest } = props
    return <p ref={ref}
              className={`font-medium uppercase text-xxs ${className ?? ''}`} {...rest}>{props.children}</p>
  }
)